import { CognitoUserPool } from "amazon-cognito-identity-js";

const poolData = {
  UserPoolId: "us-east-1_eMj7mn8sN",
  ClientId: "bmmpfhsjfunq4se0ste0806k0",
  Region: "us-east-1"  // Adding region explicitly
};

const userPool = new CognitoUserPool(poolData);

// Add validation
if (!userPool) {
  console.error('Failed to initialize Cognito User Pool');
}

export default userPool;
